import React, { ComponentProps } from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { HorizontalScrollRail, theme, useContainerSpacing, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const HomeCategory = (props: ComponentProps<typeof HorizontalScrollRail>) => {
  const { children } = props;

  const { currentBreakpoint } = useResponsive();

  // ───────────────────────────────────────────────────────────────────────────

  if (currentBreakpoint.isXS) {
    return <HomeCategoryScrollView>{children}</HomeCategoryScrollView>;
  }

  return <HomeCategoryFlexView>{children}</HomeCategoryFlexView>;
};

const HomeCategoryScrollView = (props: ComponentProps<typeof HorizontalScrollRail>) => {
  const containerSpacing = useContainerSpacing();
  const contentContainerStyles = useStyle(
    () => ({
      paddingHorizontal: containerSpacing,
      columnGap: theme.spacing['6'],
    }),
    [containerSpacing],
  );

  return (
    <HorizontalScrollRail
      outerOffset={0}
      showNavControls={false}
      gap={theme.spacing['6']}
      contentContainerStyle={contentContainerStyles}
    >
      {props.children}
    </HorizontalScrollRail>
  );
};

const HomeCategoryFlexView = (props: Pick<ViewProps, 'style' | 'children'>) => {
  return <View style={[styles.flexView, props.style]}>{props.children}</View>;
};

HomeCategory.ScrollView = HomeCategoryScrollView;
HomeCategory.FlexView = HomeCategoryFlexView;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  flexView: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing['6'],
  },
});
